import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Dashboard.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashAlt, faPlus } from '@fortawesome/free-solid-svg-icons';
import { baseUrl } from '../components/constant';
import { toast } from 'react-toastify';

const SubCategories = () => {
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [categoryToDelete, setCategoryToDelete] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [selectedCategory, setSelectedCategory] = useState(null); // Track the selected category

  const navigate = useNavigate();

  // Fetch all categories for the dropdown
  const fetchCategories = async () => {
    setLoading(true);
    try {
      const token = JSON.parse(localStorage.getItem('token'));
      const response = await fetch(`https://dashboard.onyxen-regalia.com/backend/api/categories`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        setCategories(data.categories); // Adjust based on your API response structure
      } else {
        toast.error('Failed to fetch categories');
      }
    } catch (err) {
      setError('Failed to fetch categories');
    } finally {
      setLoading(false);
    }
  };

  // Fetch subcategories based on selected category
  const fetchSubcategories = async (categoryId) => {
    setLoading(true);
    try {
      const token = JSON.parse(localStorage.getItem('token'));
      //   const response = await fetch(`${baseUrl}/categories/${categoryId}/subcategories?page=${currentPage}`, {
      console.log("sub url", `${baseUrl}/categories/subcategories/${categoryId}`)
      const response = await fetch(`${baseUrl}/categories/subcategories/${categoryId}`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        setSubcategories(data.subcategories); // Adjust based on your API response structure
        // setLastPage(data.last_page); // Adjust based on your API response structure
      } else {
        toast.error('Failed to fetch subcategories');
      }
    } catch (err) {
      console.log("err", err)
      setError('Failed to fetch subcategories');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  useEffect(() => {
    if (selectedCategory) {
      console.log("selectedCategory", selectedCategory)
      fetchSubcategories(selectedCategory); // Fetch subcategories when a category is selected
    }
  }, [selectedCategory]);

  const handleEditClick = (subcategory) => {
    navigate(`/SubCategories/edit/${subcategory.id}`, { state: { selectedCategory, subcategory } });
  };

  const handleDeleteClick = (subcategory) => {
    setCategoryToDelete(subcategory);
    setShowModal(true);
  };

  console.log("categories", categories)
  const confirmDelete = async () => {
    if (!categoryToDelete) return;

    setLoading(true);
    try {
      const token = JSON.parse(localStorage.getItem('token'));
      const response = await fetch(`${baseUrl}/categories/subcategories/${categoryToDelete.id}`, {
        method: 'DELETE',
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      if (response.ok) {
        toast.success('Category deleted successfully!');
        // Remove the deleted subcategory from the state
        setSubcategories(subcategories.filter(subcategory => subcategory.id !== categoryToDelete.id));
        setShowModal(false); // Close the modal after successful deletion
      } else {
        toast.error('Failed to delete category');
      }
    } catch (err) {
      toast.error('An error occurred while deleting the category.');
    } finally {
      setLoading(false);
    }
  };

  const cancelDelete = () => {
    setShowModal(false);
    setCategoryToDelete(null);
  };

  const handleAddNewCategory = () => {
    // navigate('/Categories/new-category');
    navigate(`/SubCategories/new`, { state: { selectedCategory } });

  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < lastPage) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handleCategoryEdit = (category) => {
    console.log("category",category)
    // setSelectedCategory(category);
    navigate(`/SubCategories/edit/${category.id}`, { state: { subcategory:category } });
  };
console.log("subcategories",subcategories)
  return (
    <div className="dashboard">
      {/* Category Dropdown */}
      <div className="dropdown-container" style={{ width: '100%', padding: '0 20px', marginBottom: '20px' }}>
        <select
          style={{
            width: '100%',
            height: '100px',
            fontSize: '18px',
            padding: '0 20px', // Horizontal padding for the select box
            appearance: 'none', // Hides the default arrow
            background: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='black'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E") no-repeat right 20px center`, // Custom arrow
            backgroundSize: '20px', // Adjust the size of the arrow
            backgroundColor: '#fff', // Background color of the select
            borderRadius: '5px', // Optional: Add border-radius for a rounded look
            border: '1px solid #ccc', // Optional: Border style
            color: '#000', // Ensures the text color is black
          }}
          onChange={(e) => setSelectedCategory(e.target.value)}
          value={selectedCategory || ''}
        >
          <option value="" disabled>Select a Category</option>
          {categories.map((category) => (
            category.parent_id == null &&
            <option key={category.id} value={category.id} style={{ color: '#000' }}>
              {category.name.en}{"-"}{category.name.ar}
            </option>
          ))}
        </select>
      </div>

      <button className="add-category-button" onClick={handleAddNewCategory} style={{ backgroundColor: 'rgb(154, 57, 57)' }}>
        <FontAwesomeIcon icon={faPlus} size='20px' /> Add New Category
      </button>

      <div className="category-list">
        {loading && (
          <div className="loader-overlay">
            <div className="loader"></div>
          </div>
        )}
        {!loading && subcategories.map(subcategory => (
          <div key={subcategory.id} className="category-item">
            <div className="category-row">
              <span className="category-id">ID: {subcategory.id}</span>
              {/* <img src={subcategory.image} alt={subcategory.name} className="category-image" /> */}
              <h3 className="category-name" style={{ color: "rgb(154, 57, 57)" }}>{subcategory.name.en}{' - '}{subcategory.name.ar}</h3>
              <div className="buttons">
                {/* <button className="edit" onClick={() => handleEditClick(subcategory)}>
                  <FontAwesomeIcon icon={faEdit} color='rgb(154, 57, 57)' />
                </button> */}
                <button className="delete" onClick={() => handleDeleteClick(subcategory)}>
                  <FontAwesomeIcon icon={faTrashAlt} color='#000' />
                </button>

                <button className="edit" onClick={()=> handleCategoryEdit(subcategory)}>
                <p>Edit</p>
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {lastPage > 1 && (
        <div className="pagination-controls">
          <button
            onClick={handlePreviousPage}
            disabled={currentPage === 1}
            style={{ marginRight: '10px', backgroundColor: 'rgb(154, 57, 57)', color: '#fff' }}
          >
            Previous
          </button>
          <span>Page {currentPage} of {lastPage}</span>
          <button
            onClick={handleNextPage}
            disabled={currentPage === lastPage}
            style={{ marginLeft: '10px', backgroundColor: 'rgb(154, 57, 57)', color: '#fff' }}
          >
            Next
          </button>
        </div>
      )}

      {showModal && (
        <div className="modal show">
          <div className="modal-content">
            <h3 style={{ color: '#000' }}>Are you sure you want to delete this category?</h3>
            <button className="cancel-button" onClick={cancelDelete} style={{ backgroundColor: "#000" }}>Cancel</button>
            <button className="delete-button" onClick={confirmDelete} style={{ backgroundColor: 'rgb(154, 57, 57)' }}>Delete</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SubCategories;
